import { render } from "./ThePositionItem.vue?vue&type=template&id=f7230664&scoped=true&ts=true"
import script from "./ThePositionItem.vue?vue&type=script&lang=ts"
export * from "./ThePositionItem.vue?vue&type=script&lang=ts"

import "./ThePositionItem.vue?vue&type=style&index=0&id=f7230664&scoped=true&lang=scss"

import exportComponent from "/data/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f7230664"]])

export default __exports__